import { render, staticRenderFns } from "./user-detail.vue?vue&type=template&id=2ba362bb&scoped=true&"
import script from "./user-detail.vue?vue&type=script&lang=js&"
export * from "./user-detail.vue?vue&type=script&lang=js&"
import style0 from "./user-detail.vue?vue&type=style&index=0&id=2ba362bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba362bb",
  null
  
)

component.options.__file = "user-detail.vue"
export default component.exports